module.exports = __webpack_public_path__ + "img/timeline-02.1df88817.jpg";